module.exports = __webpack_public_path__ + "media/4x3/zw-6ac3949a.svg";